export default function( num ) {
	if ( num ) {
		return num.toString().replace( /(\d{3})(\d{3})(\d{4})/, "($1) $2-$3" );
	}

	return num;
}
